export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_ELEMENTS = 'SET_PROJECT_ELEMENTS';
export const SET_SELECTED_PROJECT_ELEMENT_ID = 'SET_SELECTED_PROJECT_ELEMENT_ID';
export const SET_SELECTED_MESH_ID = 'SET_SELECTED_MESH_ID';
export const SET_SELECTED_MESH = 'SET_SELECTED_MESH';
export const SET_IS_OPTIMIZED_VIEW = 'SET_IS_OPTIMIZED_VIEW';
export const SET_SELECTED_REFERENCE = 'SET_SELECTED_REFERENCE';

export const setSelectedProject = (selectedProject) => ({ type: SET_PROJECT, selectedProject });

export const setProjectElements = (elements) => ({ type: SET_PROJECT_ELEMENTS, elements });

export const setSelectedProjectElementId = (selectedProjectElementId) => ({ type: SET_SELECTED_PROJECT_ELEMENT_ID, selectedProjectElementId });

export const setSelectedMeshId = (selectedMeshId) => ({ type: SET_SELECTED_MESH_ID, selectedMeshId });

export const setSelectedMesh = (selectedMesh) => ({ type: SET_SELECTED_MESH, selectedMesh });

export const setIsOptimizedView = (isOptimizedView) => ({ type: SET_IS_OPTIMIZED_VIEW, isOptimizedView });

export const setProjectIsLoading = (projectIsLoading) => ({ type: "SET_PROJECT_IS_LOADING", projectIsLoading });

export const setSideBarIsOpened = (sideBarIsOpened) => ({ type: "SET_SIDEBAR_IS_OPENED", sideBarIsOpened });

export const setUsdzUploadProgress = (usdzUploadProgress) => ({ type: 'SET_USDZ_UPLOAD_PROGRESS', usdzUploadProgress });

export const setUsdzUrl = (usdzUrl) => ({ type: 'SET_USDZ_URL', usdzUrl });

export const setRegenerateUsdz = (regenerateUsdz) => ({ type: 'SET_REGENERATE_USDZ', regenerateUsdz });

export const setSelectedReference = (selectedReference) => ({ type: 'SET_SELECTED_REFERENCE', selectedReference });
